import { api } from '@/core/helpers/axiosHelper';

export default {
   async update(BODY: { preferenceable_type: string; preferenceable_id: number; preference_type_key: string; value: any }) {
      return await api.put('/preference', BODY).then((response) => response.data);
   },
};
